<template>
	<div class="c-email-selector" ref="scrollContainer">
		<div class="c-email-selector__contact">
			<div class="c-email-selector__contact__avatar blank">
				<b-dropdown id="dropdown-dropup" dropup class="m-2">
					<form @submit.prevent="onCreateContact">
						<input
							class="form-control"
							placeholder="name@email.com"
							v-model="contactEmail"
						/>
					</form>
				</b-dropdown>
			</div>

			<span>Create Contact</span>
		</div>
		<div
			class="c-email-selector__contact"
			v-for="contact in contacts"
			:key="contact.email"
		>
			<div class="c-email-selector__contact__avatar">
				<img :src="contact.avatar" />
			</div>
			<span>{{ contact.name }}</span>
		</div>
	</div>
</template>

<script>
import md5 from '@/lib/md5.js';

export default {
	data: function () {
		return {
			contactEmail: '',
			contacts: [
				{
					email: 'shash@underlineme.com',
					name: 'Shash',
					avatar:
						'https://images.unsplash.com/photo-1622495806291-29f2d2270e7d?ixid=MnwxMjA3fDF8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=986&q=80',
				},
				{
					email: 'shash122tfu@gmail.com',
					name: 'shash122tfu',
					avatar:
						'https://images.unsplash.com/photo-1622495806291-29f2d2270e7d?ixid=MnwxMjA3fDF8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=986&q=80',
				},
			],
		};
	},

	methods: {
		onCreateContact: function () {
			let hash = md5(this.contactEmail.toLowerCase());
			this.contacts.push({
				email: this.contactEmail,
				name: '',
				avatar: 'https://www.gravatar.com/avatar/' + hash,
			});
		},
	},

	mounted: function () {
		const content = this.$refs.scrollContainer;
		//Firefox
		if (content.addEventListener) {
			content.addEventListener(
				'DOMMouseScroll',
				function (e) {
					content.scrollBy(-e.wheelDelta, 0);
				},
				false
			);
		}
		//IE
		if (content.attachEvent) {
			content.attachEvent('onmousewheel', function (e) {
				content.scrollBy(-e.wheelDelta, 0);
			});
		}
		//Chrome
		content.onmousewheel = function (e) {
			content.scrollBy(-e.wheelDelta, 0);
		};
	},
};
</script>

<style lang="scss">
.c-email-selector {
	width: 100%;
	max-width: 100%;
	overflow-x: auto;
	white-space: nowrap;
	@include scrollBars();

	&__contact {
		display: inline-flex;
		flex-direction: column;
		align-items: center;
		padding: var(--margin) 0;
		width: calc(var(--spacer-lg) + var(--spacer-sm));
		text-align: center;
		white-space: initial;

		&__avatar {
			display: inline-block;
			width: var(--spacer-lg);
			height: var(--spacer-lg);
			margin-bottom: var(--margin);
			border-radius: 50%;
			border: transparent dashed 2px;
			overflow: hidden;
			cursor: pointer;

			.dropdown {
				width: 100%;
				height: 100%;

				> button {
					width: 100%;
					height: 100%;
					border-radius: 50%;
				}

				input {
					margin: 0;
				}
			}

			&.blank {
				overflow: initial;
				border: rgba(255, 255, 255, 0.5) dashed 2px;
			}

			> img {
				width: 100%;
				height: 100%;
				object-fit: cover;
			}

			&:focus,
			&:hover,
			&:active {
				@include focus();
			}
		}
		> span {
			display: inline-block;
			line-height: 1.25;
			font-size: var(--font-size-xs);
		}
	}
}
</style>